import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { getSchoolSubAdmins } from "store/actions/schoolAction";
import TableComponent from "./TableComponent";

const ShowSchoolsSubAdminsModal = ({ isOpen, toggle, id }) => {
  let dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(false);
  const { schoolSubAdmins } = useSelector((state) => state.school);
  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getSchoolSubAdmins(id, () => {
        setDataLoader(false);
      })
    );
  }, [id]);
  const column = ["Name", "Email", "Photo"];
  const keyMaps = {
    Name: "name",
    Email: "email",
    Photo: "img",
  };
  const formattedData = (data) => {
    return data?.map((item) => ({
      ...item,
      img: <img src={item.admin_image.url} width={"100px"} />,
    }));
  };
  return (
    <Modal isOpen={isOpen} centered toggle={toggle} size="lg">
      <ModalBody>
        {dataLoader ? (
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <TableComponent
            columns={column}
            data={schoolSubAdmins ? formattedData(schoolSubAdmins) : []}
            keyMap={keyMaps}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ShowSchoolsSubAdminsModal;
